import { FC, useEffect } from "react";
import Search from "../../components/UI/Icons/Search";
import { useLocation, useNavigate } from "react-router";
import { NON_AUTH_ROUTE } from "../App/routes";

const NotFoundLoggedOut: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLoginPage = () => {
    navigate(NON_AUTH_ROUTE.LOGIN);
  };

  useEffect(() => {
    navigate("/not-found", { state: { is404: true }, replace: true });
  }, []);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center gap-20 text-center">
      <div className="w-60px h-60px bg-teal-light rounded-circle d-flex align-items-center justify-content-center">
        <Search size={40} />
      </div>
      <div className="fs-30 fw-400 text-black">Page not found</div>
      <div className="fs-16 fw-400 text-black">
        This page link might be broken or has been removed.
      </div>
      <div className="fs-16 fw-400 text-black">
        Please try reloading the{" "}
        <span
          className="fw-700 text-decoration-underline cursor-pointer"
          onClick={handleLoginPage}
        >
          Login Page
        </span>
        .
      </div>
    </div>
  );
};

export default NotFoundLoggedOut;
